import React, { useState, useEffect, useRef } from "react";
import { LayoutHome } from "../LayoutHome";
import {
  notification,
  Input,
  Table as TBL,
  Button,
  Space,
  Splitter,
} from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  Col,
  Row,
  SelectPicker,
  Text,
  Card,
  Panel,
  Accordion,
  Button as Btn,
  Tag,
  Drawer,
  Carousel,
  List,
  IconButton,
  Textarea,
  Breadcrumb,
  Tabs,
} from "rsuite";
import {
  getExpediente,
  getListPacientes,
  getDatosPaciente,
} from "../Services/PacientesServices";
import { Save, SearchIcon } from "lucide-react";
import {
  getDatosCitaPorIdConsulta,
  getAntecedentes,
  getDocsCita,
  getUltimaFecHosp,
  saveDocExpediente,
} from "../Services/ConsultasServices";
import { getHojasPaciente } from "../Services/HojaEnfermeria";
import { getNotasMedPaciente } from "../Services/NotaMedica";
import moment from "moment/moment";
import Table from "react-bootstrap/Table";
import { LucideZoomIn } from "lucide-react";
import { render } from "@testing-library/react";
import { LaboratoriosView } from "./LaboratoriosView";

export const Expedientes = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [nombreMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).medico.medico,
  );

  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [permiso] = useState(localStorage.getItem("permiso"));

  const [appConfigParams] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp,
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DATOS GENERALES DEL PACIENTE
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [dataPacientes, setDataPacientes] = useState([]);
  const [fecNac, setFecNac] = useState("");
  const [edad, setEdad] = useState(0);
  const [genero, setGenero] = useState("");
  const [fechaHosp, setFechaHosp] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DATOS DEL PACIENTE

  // ------------------------------------------------------------ HISTORICOS DE EXPLORACION ------------------------------
  const [frecCardiacaEx, setFrecCardiacaEx] = useState("");
  const [frecRespEx, setFrecRespEx] = useState("");
  const [tempEx, setTempEx] = useState("");
  const [presionArtEx, setPresioArtEx] = useState("");
  const [pesoEx, setPesoEx] = useState("");
  const [tallaEx, setTallaEx] = useState("");
  const [imcEx, setImcEx] = useState("");
  const [saturaOxEx, setSaturaOxEx] = useState("");
  const [glicemiaCapEx, setGlicemiaCapEx] = useState("");
  const [otrosDatosExploraEx, setOtrosDatosExploraEx] = useState("");
  const [labsEstudiosEx, setLabsEstudiosEx] = useState("");
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> FIN DE VARIABLES DE EXPLORACION FISICA

  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);
  const [dataExped, setDataExped] = useState([]);
  const [dataHojas, setDataHojas] = useState([]);
  const [dataNotas, setDataNotas] = useState([]);
  const [idConsulta, setIdConsulta] = useState(0);
  const [sortColumnExped, setSortColumnExped] = useState();
  const [sortTypeExped, setSortTypeExped] = useState();
  const [indicaciones, setIndicaciones] = useState("");
  const [tituloDrawer, setTituloDrawer] = useState("");
  const [observaCita, setObservaCita] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [sortColumn, setSortColumn] = useState();
  const [open, setOpen] = useState(false);
  const [motivoEx, setMotivoEx] = useState("");
  const [sortType, setSortType] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingExped, setLoadingExped] = useState(false);
  const [dataSignosEx, setdataSignosEx] = useState([]);
  const [modalReceta, setModalReceta] = useState(false);
  const [valueGpo1, setValueGpo1] = useState("");
  const [valueGpo2, setValueGpo2] = useState("");
  const [valueGpo3, setValueGpo3] = useState("");
  const [valueGpo4, setValueGpo4] = useState("");
  const [fileList, setFileList] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);

  const { Column, HeaderCell, Cell } = Table;

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);

  const getDetalles = async (props) => {
    getDatosCita(props.idC);
    setTituloDrawer(props.titulo);
    setDiagnostico(props.diagnostico);
    setTratamiento(props.tratamiento);
    setIndicaciones(props.indicaciones);
    setObservaCita(props.observa);
    setOpen(true);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "Folio",
      dataIndex: "idConsulta",
      width: "6%",
      key: "idConsulta",
      align: "center",
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      width: "10%",
      key: "fecha",
      align: "center",
      sorter: (a, b) => a.fecha.length - b.fecha.length,
      ...getColumnSearchProps("fecha"),
    },
    {
      title: "Motivo consulta",
      dataIndex: "motivoConsulta",
      key: "motivoConsulta",
      sorter: (a, b) => a.motivoConsulta.length - b.motivoConsulta.length,
      ...getColumnSearchProps("motivoConsulta"),
    },
    {
      title: "Diagnostico",
      dataIndex: "diagnostico",
      key: "diagnostico",
      sorter: (a, b) => a.diagnostico.length - b.diagnostico.length,
      ...getColumnSearchProps("diagnostico"),
    },
    {
      title: "Nota de evolución",
      dataIndex: "notaEvol",
      key: "notaEvol",
      sorter: (a, b) => a.notaEvol.length - b.notaEvol.length,
      ...getColumnSearchProps("notaEvol"),
    },
    {
      title: "Indicaciones",
      dataIndex: "indicaciones",
      key: "indicaciones",
      sorter: (a, b) => a.inidcaciones.length - b.indicaciones.length,
      ...getColumnSearchProps("indicaciones"),
    },
    {
      title: "...",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<LucideZoomIn />}
          color="primary"
          variant="text"
          onClick={() =>
            getDetalles({
              idC: record.idConsulta,
              idPac: idPaciente,
              titulo: `EXPED-${record.idExped}-${record.idConsulta} / Fecha: ${record.fecha}`,
              diagnostico: record.diagnostico,
              tratamiento: record.tratamiento,
              indicaciones: record.inidcaciones,
              observa: record.observa,
            })
          }
        ></Button>
      ),
    },
  ];

  const columnsHojas = [
    {
      title: "Folio",
      dataIndex: "idHoja",
      width: "6%",
      key: "idHoja",
      align: "center",
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      width: "10%",
      key: "fecha",
      align: "center",
      sorter: (a, b) => a.fecha.length - b.fecha.length,
      ...getColumnSearchProps("fecha"),
    },
    {
      title: "Enferemera(o)",
      dataIndex: "enfermera",
      key: "enfermera",
      sorter: (a, b) => a.enfermera.length - b.enfermera.length,
      ...getColumnSearchProps("enfermera"),
    },
    {
      title: "...",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<LucideZoomIn />}
          color="primary"
          variant="text"
          onClick={() =>
            showDocumento({
              folio: record.idSesion,
              doc: "Hoja",
            })
          }
        ></Button>
      ),
    },
  ];

  const columnsNotas = [
    {
      title: "Folio",
      dataIndex: "idNota",
      width: "6%",
      key: "idNota",
      align: "center",
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      width: "10%",
      key: "fecha",
      align: "center",
      sorter: (a, b) => a.fecha.length - b.fecha.length,
      ...getColumnSearchProps("fecha"),
      render: (text) => moment(text).format("DD-MM-YYYY"),
    },
    {
      title: "Médico",
      dataIndex: "medico",
      key: "medico",
      sorter: (a, b) => a.medico.length - b.medico.length,
      ...getColumnSearchProps("medico"),
    },
    {
      title: "...",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<LucideZoomIn />}
          color="primary"
          variant="text"
          onClick={() =>
            showDocumento({
              folio: record.idSesion,
              doc: "Nota",
            })
          }
        ></Button>
      ),
    },
  ];

  const getListaHojas = async (idPac) => {
    await getHojasPaciente(idNegocio, idPac)
      .then(async (res) => {
        setDataHojas(res);
      })
      .then(async (res) => {
        await getNotasMedPaciente(idNegocio, idPac).then((res) => {
          setDataNotas(res);
        });
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const showDocumento = (props) => {
    if (props.doc === "Hoja") {
      window.open(
        `/#/App/Home/HojaEnfermeriaView/${props.folio}/${idPaciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    } else {
      window.open(
        `/#/App/Home/NotaMedicaView/${props.folio}/${idPaciente}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const getFinalText = (text) => {
    const lines = text.split("\n");
    return (
      <div>
        {lines.map((item, index) => (
          <React.Fragment key={index}>
            {item}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const getDatosCita = async (idCons) => {
    const response = await getDatosCitaPorIdConsulta(idNegocio, idCons);
    // DATOS DE EXPLORACION FISICA
    setFrecCardiacaEx(response.dataSignos.frecCardiaca);
    setFrecRespEx(response.dataSignos.frecResp);
    setTempEx(response.dataSignos.temp);
    setPresioArtEx(response.dataSignos.presionArt);
    setPesoEx(response.dataSignos.peso);
    setTallaEx(response.dataSignos.talla);
    setImcEx(response.dataSignos.imc);
    setSaturaOxEx(response.dataSignos.saturaOx);
    setGlicemiaCapEx(response.dataSignos.glicemiaCap);
    setOtrosDatosExploraEx(response.dataSignos.otrosDatosExp);
    setLabsEstudiosEx(response.dataSignos.labsEstudios);
    setdataSignosEx(response.dataExplora);
    setMotivoEx(response.motivo);
    setIdConsulta(response.idConsulta);
    setFileList([]);

    await getDocsCita(idNegocio, response.idConsulta).then((res) => {
      let doc = [];
      res.forEach((element) => {
        if (element.NombreDoc !== "Sin_Doc") {
          doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
        }
      });
      setImageList(doc);
    });
  };

  const handleChangeValueExplora = (e, idGpo) => {
    if (idGpo === 1) {
      setValueGpo1(e);
    }
    if (idGpo === 2) {
      setValueGpo2(e);
    }
    if (idGpo === 3) {
      setValueGpo3(e);
    }
    if (idGpo === 4) {
      setValueGpo4(e);
    }
  };

  const loadPacientes = async (e) => {
    if (e === null) {
      setDataPacientes([]);
      return;
    }

    await getListPacientes(idNegocio)
      .then((res) => {
        setDataPacientes(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadAntecedentes = async (idPac) => {
    await getAntecedentes(idNegocio, idPac)
      .then((res) => {
        setListaAnteced(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const handleFileList = async (e) => {
    setFileList(Array.from(e.target.files));

    const formData = new FormData();
    Array.from(e.target.files).forEach((file) => {
      formData.append("file", file);
    });

    formData.append("id", idNegocio);
    formData.append("idConsulta", idConsulta);
    formData.append("idPaciente", idPaciente);

    await saveDocExpediente(formData)
      .then(async (res) => {
        if (res > 0) {
          successNotification("Documento", "Se ha guardado el archivo.");
          await getDocsCita(idNegocio, idConsulta).then((res) => {
            let doc = [];
            res.forEach((element) => {
              if (element.NombreDoc !== "Sin_Doc") {
                doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
              }
            });
            setImageList(doc);
          });
        } else {
          errorNotificaction("Error_Doc", "Error al guardar el archivo...");
        }
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const datosPaciente = async (idPac) => {
    if (idPac === null) {
      setFecNac("");
      setEdad("0");
      setGenero("");
      return;
    }

    setIdPaciente(idPac);
    const selectedItem = dataPacientes.find((item) => item.value === idPac);
    const text = selectedItem.label;
    setPaciente(text);

    await getDatosPaciente(idNegocio, idPac)
      .then(async (response) => {
        let _fecha = response.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(response.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
          setFecNac(moment(_fecNac).format("DD-MMM-YYYY").toUpperCase());
        } else {
          setEdad(0);
          setFecNac(null);
        }
        setGenero(response.genero);
        loadAntecedentes(idPac)
          .then(async (res) => {
            getExpedientePaciente(idPac);
          })
          .then(async (res) => {
            const _res = await getUltimaFecHosp(idNegocio, idPac);
            setFechaHosp(_res);
          })
          .then((res) => {
            getListaHojas(idPac);
          });
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const getExpedientePaciente = async (ID) => {
    await getExpediente(idNegocio, ID)
      .then((res) => {
        setDataExped(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadPacientes();
    }
  }, []);

  return (
    <>
      <title>Expedientes</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Expedientes" },
        ]}
        selectedKey={"Expedientes"}
      >
        {contextHolder}

        <Panel bordered>
          <Row gutter={20}>
            <Col span={8}>
              <Text weight="semibold">Nombre del paciente</Text>
              <SelectPicker
                block
                value={idPaciente}
                data={dataPacientes}
                placeholder="-- SELECCIONA --"
                onChange={(e) => datosPaciente(e)}
              />
            </Col>
            <Col span={4}>
              <Text weight="semibold">Fecha hospitalización</Text>
              <Input readOnly variant="underlined" value={fechaHosp} />
            </Col>
            <Col span={4}>
              <Text weight="semibold">Fecha de nacimiento</Text>
              <Input readOnly variant="underlined" value={fecNac} />
            </Col>
            <Col span={4} style={{ textAlign: "center" }}>
              <Text weight="semibold">Edad</Text>
              <Input
                readOnly
                variant="underlined"
                value={edad}
                style={{ textAlign: "center " }}
              />
            </Col>
            <Col span={4}>
              <Text weight="semibold">Genero</Text>
              <Input readOnly variant="underlined" value={genero} />
            </Col>
          </Row>
        </Panel>
        <br></br>
        <Panel bordered>
          <Tabs defaultActiveKey={1} style={{ marginBottom: "10px" }}>
            <Tabs.Tab
              eventKey={1}
              title="Antecedentes"
              disabled={permiso === "L" ? true : false}
            >
              <Panel
                header={<Text size="sm">Historial de Antecedentes</Text>}
                collapsible
                bordered
                disabled={permiso === "L" ? true : false}
              >
                {listaAnteced.length > 0
                  ? listaAnteced.map((itm, index) => {
                      return (
                        <div key={`div-${index}`}>
                          <Table
                            striped
                            bordered
                            hover
                            responsive
                            key={`tbl-${index}`}
                            style={{
                              width: "100%",
                              cellPadding: "5",
                              cellSpacing: "10",
                              fontSize: isMobile ? "10px" : "14px",
                            }}
                            cellPadding={10}
                            cellSpacing={10}
                          >
                            <thead key={`headers-${index}`}>
                              <tr
                                key={`fila-${index}`}
                                style={{
                                  borderBottom: "solid 2px",
                                  paddingBottom: "15",
                                }}
                              >
                                {isMobile ? (
                                  ""
                                ) : (
                                  <th
                                    key={`header0-${index}`}
                                    style={{
                                      textAlign: "center",
                                      width: "5%",
                                    }}
                                  >
                                    <b>#</b>
                                  </th>
                                )}
                                <th
                                  key={`header1-${index}`}
                                  style={{ width: "30%" }}
                                >
                                  <b>Item</b>
                                </th>
                                <th
                                  key={`header2-${index}`}
                                  style={{
                                    width: "15%",
                                    textAlign: "center",
                                  }}
                                >
                                  <b>Respuesta</b>
                                </th>
                                <th
                                  key={`header3-${index}`}
                                  style={{ width: "50%" }}
                                >
                                  <b>Observaciones</b>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {itm.detalles.map((item, ix) => {
                                return (
                                  <tr key={`fila-${ix}`}>
                                    {isMobile ? (
                                      ""
                                    ) : (
                                      <td
                                        key={`celda1-${ix}`}
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.id}
                                      </td>
                                    )}
                                    <td key={`celda2${index}-${ix}`}>
                                      {item.Item}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.valorado}
                                    </td>
                                    <td key={`obs-${index}${ix}`}>
                                      {item.observacion}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      );
                    })
                  : ""}
              </Panel>
            </Tabs.Tab>
            <Tabs.Tab
              eventKey={2}
              title="Consultas médicas"
              disabled={permiso === "L" ? true : false}
            >
              <div className="row">
                <div className="col">
                  <TBL
                    key={`tblConsultas`}
                    bordered
                    size="small"
                    rowKey={(record) => record.idConsulta}
                    columns={columns}
                    dataSource={dataExped}
                    pagination={{ pageSize: 10 }}
                  />
                </div>
              </div>
            </Tabs.Tab>
            <Tabs.Tab eventKey={3} title="Sesiones de Hemodiálisis">
              <div className="row">
                <div className="col">
                  <Splitter>
                    <Splitter.Panel
                      style={{ padding: "2px", overflowX: "hidden" }}
                      defaultSize="50%"
                      min="40%"
                      max="80%"
                    >
                      <TBL
                        key={`tblHojas`}
                        bordered
                        size="small"
                        rowKey={(record) => record.idHoja}
                        columns={columnsHojas}
                        dataSource={dataHojas}
                        pagination={{ pageSize: 5 }}
                      />
                    </Splitter.Panel>
                    <Splitter.Panel
                      style={{ padding: "2px", overflowX: "hidden" }}
                      defaultSize="50%"
                      min="40%"
                      max="80%"
                    >
                      <TBL
                        key={`tblNotas`}
                        bordered
                        size="small"
                        rowKey={(record) => record.idNota}
                        columns={columnsNotas}
                        dataSource={dataNotas}
                        pagination={{ pageSize: 5 }}
                      />
                    </Splitter.Panel>
                  </Splitter>
                </div>
              </div>
            </Tabs.Tab>
            <Tabs.Tab
              eventKey={4}
              title="Historico de Laboratorios"
              disabled={permiso === "L" ? true : false}
            >
              <LaboratoriosView idPaciente={idPaciente} />
            </Tabs.Tab>
          </Tabs>
        </Panel>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER EXPEDIENTE PACIENTE */}
        <Drawer size="xxl" open={open} onClose={() => setOpen(false)}>
          <Drawer.Header>
            <Drawer.Title>
              {paciente} <br /> {tituloDrawer}
            </Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <div className="row mb-1">
              <div className="col">
                <Text size={"md"} weight="bold">
                  Motivo de consulta
                </Text>
                {motivoEx}
              </div>
            </div>
            {appConfigParams.mostrarExplora === 1 ? (
              <div className="row mb-1">
                <div className="col">
                  <Panel
                    bordered
                    header="Exploración Física"
                    defaultExpanded
                    collapsible
                    key="panelExploraFisExpedinete"
                  >
                    <div className="row mb-2">
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Peso</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={pesoEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Talla</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={tallaEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">IMC</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={imcEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Presión arterial">
                          TA
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={presionArtEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Frec. Cardiaca">
                          FC
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={frecCardiacaEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Frec. Respiratoria">
                          FR
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={frecRespEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Temperatura">
                          <b>T</b>emperatura
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={tempEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm" title="Saturación de O2">
                          Sp<b>O</b>2
                        </Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={saturaOxEx}
                          readOnly
                        />
                      </div>
                      <div className="text-center col-lg-1 col-md-1 col-sm-1">
                        <Text size="sm">Glicemia capilar</Text>
                        <Input
                          style={{ textAlign: "center" }}
                          value={glicemiaCapEx}
                          readOnly
                        />
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <Text size="sm">Otros datos</Text>
                        <Input
                          as="textarea"
                          placeholder="Generales de la exploración..."
                          rows={3}
                          value={otrosDatosExploraEx}
                          readOnly
                        />
                      </div>
                    </div>
                    {dataSignosEx.length > 0 ? (
                      <div className="row mb-2">
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Card key={`card1-Ex`}>
                            <Card.Header
                              style={{ fontSize: "12px" }}
                              key={`cardHeader-1-Ex`}
                            >
                              <b>{dataSignosEx[0].nombre}</b>
                            </Card.Header>
                            <Card.Body key={`cardBody-1-Ex`}>
                              <Textarea
                                key={`gpo1-Ex`}
                                rows={4}
                                readOnly
                                value={dataSignosEx[0].items[0]}
                                onChange={(e) =>
                                  handleChangeValueExplora(
                                    e,
                                    dataSignosEx[0].idGpo,
                                  )
                                }
                              />
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Card key={`card2-Ex`}>
                            <Card.Header
                              style={{ fontSize: "12px" }}
                              key={`cardHeader-2-Ex`}
                            >
                              <b>{dataSignosEx[1].nombre}</b>
                            </Card.Header>
                            <Card.Body key={`cardBody-2-Ex`}>
                              <Textarea
                                key={`gpo2-Ex`}
                                rows={4}
                                readOnly
                                value={dataSignosEx[1].items[0]}
                                onChange={(e) =>
                                  handleChangeValueExplora(
                                    e,
                                    dataSignosEx[1].idGpo,
                                  )
                                }
                              />
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Card key={`card-3-Ex`}>
                            <Card.Header
                              style={{ fontSize: "12px" }}
                              key={`cardHeader-3-Ex`}
                            >
                              <b>{dataSignosEx[2].nombre}</b>
                            </Card.Header>
                            <Card.Body key={`cardBody-3-Ex`}>
                              <Textarea
                                key={`gpo3-Ex`}
                                rows={4}
                                readOnly
                                value={dataSignosEx[2].items[0]}
                                onChange={(e) =>
                                  handleChangeValueExplora(
                                    e,
                                    dataSignosEx[2].idGpo,
                                  )
                                }
                              />
                            </Card.Body>
                          </Card>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3">
                          <Card key={`card-4-Ex`}>
                            <Card.Header
                              style={{ fontSize: "12px" }}
                              key={`cardHeader-4-Ex`}
                            >
                              <b>{dataSignosEx[3].nombre}</b>
                            </Card.Header>
                            <Card.Body key={`cardBody-4-Ex`}>
                              <Textarea
                                key={`gpo4-Ex`}
                                rows={4}
                                readOnly
                                value={dataSignosEx[3].items[0]}
                                onChange={(e) =>
                                  handleChangeValueExplora(
                                    e,
                                    dataSignosEx[3].idGpo,
                                  )
                                }
                              />
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Panel>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row mb-2">
              <Splitter>
                <Splitter.Panel
                  style={{ padding: "2px", overflowX: "hidden" }}
                  defaultSize="50%"
                  min="40%"
                  max="80%"
                >
                  <div className="row mb-2">
                    <div className="col">
                      <List style={{ flex: 1 }} bordered>
                        <List.Item>
                          <b>Diagnostico</b>
                          <br></br> {diagnostico}
                        </List.Item>
                        <List.Item>
                          <b>Tratamiento</b>
                          <br></br> {tratamiento}
                        </List.Item>
                        <List.Item>
                          {appConfigParams.emitirReceta === 1 ? (
                            <IconButton
                              size="sm"
                              circle
                              onClick={() => setModalReceta(true)}
                              placement="left"
                              icon={<SearchIcon />}
                              appearance="ghost"
                            ></IconButton>
                          ) : (
                            ""
                          )}
                          &nbsp;
                          <b>Indicaciones</b>
                          <br></br>
                          {getFinalText(indicaciones)}
                        </List.Item>
                      </List>
                    </div>
                  </div>
                </Splitter.Panel>
                <Splitter.Panel
                  style={{ padding: "2px", overflowX: "hidden" }}
                  defaultSize="50%"
                  min="40%"
                  max="80%"
                >
                  <Panel header="Documentos" bordered>
                    <div className="row mb-2">
                      <div className="col-lg-2 col-md-2 cols-sm-2">
                        <input
                          className="form-control-sm"
                          type="file"
                          id="file"
                          onChange={(e) => handleFileList(e)}
                          multiple
                        />
                      </div>
                      <div
                        className="col"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {fileList.length > 0 && (
                          <Breadcrumb size="lg">
                            {fileList.map((file, index) => (
                              <Breadcrumb.Item key={index}>
                                {file.name}
                              </Breadcrumb.Item>
                            ))}
                          </Breadcrumb>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-4">
                        {imageList.length > 0 ? (
                          <Carousel
                            autoplay
                            autoplayInterval={4000}
                            shape="bar"
                            height={120}
                          >
                            {imageList.map((el, index) => {
                              return (
                                <div key={index}>
                                  <br></br>
                                  <ul>
                                    <a
                                      style={{ color: "white" }}
                                      href={`Unidades/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {el.doc}
                                    </a>
                                  </ul>
                                </div>
                              );
                            })}
                          </Carousel>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-lg-8 col-lg-md-8 col-sm-8">
                        <b>Notas</b>
                        <Input
                          as="textarea"
                          rows={3}
                          placeholder="Anotaciones..."
                          readOnly
                          value={observaCita}
                        />
                      </div>
                    </div>
                  </Panel>
                </Splitter.Panel>
              </Splitter>
            </div>
          </Drawer.Body>
        </Drawer>
        
      </LayoutHome>
    </>
  );
};
